import * as React from "react";
import type { SVGProps } from "react";

const MembershipCreation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.75 64.639L30.917 72.806C30.963 73.135 31.126 73.436 31.376 73.655C31.626 73.874 31.946 73.997 32.278 74H67.722C68.055 73.997 68.375 73.874 68.624 73.655C68.874 73.436 69.037 73.135 69.083 72.806L70.25 64.639H29.75Z"
      fill="#050033"
    />
    <path
      d="M70.667 61.861L74.639 34.083C74.677 33.805 74.631 33.522 74.507 33.269C74.383 33.017 74.188 32.807 73.944 32.667C73.693 32.536 73.409 32.482 73.128 32.512C72.846 32.542 72.58 32.654 72.361 32.833L60.222 43.333L51.194 22.5C51.088 22.25 50.91 22.036 50.683 21.886C50.455 21.736 50.189 21.655 49.917 21.655C49.644 21.655 49.378 21.736 49.151 21.886C48.924 22.036 48.746 22.25 48.639 22.5L39.667 43.444L27.778 32.944C27.57 32.756 27.309 32.636 27.031 32.601C26.752 32.566 26.47 32.618 26.222 32.75C25.971 32.884 25.768 33.091 25.638 33.345C25.509 33.598 25.461 33.885 25.5 34.167L29.472 61.944L70.667 61.861Z"
      fill="#050033"
    />
  </svg>
);

export default MembershipCreation;
